if (!customElements.get('shop-the-look-slider')) {
  class ShopTheLookSlider extends HTMLElement {
    constructor() {
      super();

      this.dotsList = this.querySelector('.js-dots-list');
      this.customSwiper = this.querySelector('custom-swiper');
      this.nextBtn = this.querySelector('.js-stl-next');
      this.prevBtn = this.querySelector('.js-stl-prev');

      this.init();
    }

    init() {
      if (!this.customSwiper) return;

      const waitForSwiper = () => {
        if (this.customSwiper.swiper) {
          this.slider = this.customSwiper.swiper;
          this.bindEvents();
        } else {
          requestAnimationFrame(waitForSwiper);
        }
      };
      waitForSwiper();
    }

    bindEvents() {
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.slider.slideNext());
      }
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.slider.slidePrev());
      }

      this.updateNavVisibility();

      this.dotsList?.addEventListener('click', (e) => {
        const btn = e.target.closest('.js-btn');
        if (!btn || btn.classList.contains('is-current')) return;

        e.preventDefault();
        this.updateActiveDot(btn);
        this.slider.slideTo(+btn.dataset.targetSlideIndex, 300);
      });

      this.slider.on('slideChange', () => {
        const activeSlide = this.slider.slides[this.slider.activeIndex];
        const blockIndex = activeSlide?.dataset.blockIndex;
        if (blockIndex != null) {
          const btn = this.dotsList?.querySelector(
            `.js-btn[data-block-index="${blockIndex}"]`
          );
          if (btn) this.updateActiveDot(btn);
        }
        this.updateNavVisibility();
      });

      this.slider.on('reachBeginning', () => this.updateNavVisibility());
      this.slider.on('reachEnd', () => this.updateNavVisibility());

      this.initDrawer();
    }

    updateNavVisibility() {
      if (this.prevBtn) {
        this.prevBtn.style.display = this.slider.isBeginning ? 'none' : '';
      }
      if (this.nextBtn) {
        this.nextBtn.style.display = this.slider.isEnd ? 'none' : '';
      }
    }

    connectedCallback() {}

    updateActiveDot(btn) {
      const currentBtn = this.dotsList?.querySelector('.js-btn.is-current');
      if (currentBtn) {
        currentBtn.classList.remove('is-current');
        currentBtn.setAttribute('aria-current', false);
      }
      if (btn) {
        btn.classList.add('is-current');
        btn.setAttribute('aria-current', true);
      }
    }

    initDrawer() {
      const drawerContainer = document.querySelector('shop-the-look-drawer');
      if (!drawerContainer) return;
    }
  }

  customElements.define('shop-the-look-slider', ShopTheLookSlider);
}
